import { environment } from '../../../environments/environment';

export enum AppTypeMode {
  WEB = 'web',
  MOBILE = 'mobile'
}

const appTypeMode = AppTypeMode.WEB; // Cambia entre AppTypeMode.WEB o AppTypeMode.MOBILE

const getApiUrl = (appTypeMode: AppTypeMode): string => {
  if (appTypeMode === AppTypeMode.WEB) {
    return environment.api.web.baseUrl;
  } else {
    return environment.api.mobile.baseUrl;
  }
}

const getApiKey = (appTypeMode: AppTypeMode): string => {
  if (appTypeMode === AppTypeMode.WEB) {
    return environment.api.web.apiKey;
  } else {
    return environment.api.mobile.apiKey;
  }
}

const getUseConfig = (appTypeMode: AppTypeMode): boolean => {
  if (appTypeMode === AppTypeMode.WEB) {
    return true;
  } else {
    return false;
  }
}

const current_url_api = getApiUrl(appTypeMode);
const current_api_key = getApiKey(appTypeMode);
const current_httponly_config = getUseConfig(appTypeMode);

export const API_CONFIG = {
  appTypeMode: appTypeMode,
  baseUrl: current_url_api,
  api_key: current_api_key,
  endpoints: {
    auth: {
      login: '/auth/login',
      logout: '/auth/logout',
      refresh: '/auth/refresh',
      logoutAll: '/auth/logout-all',
      me: '/auth/me',
      changePassword: '/auth/change-password'
    },
    users: '/users',
    adminUsers: {
      base: '/users',
      byId: (id: string) => `/users/${id}`,
      estado: (id: string) => `/users/${id}/estado`,
      role: (id: string) => `/users/${id}/role`,
      facturacion: (id: string) => `/users/${id}/facturacion`,
      resetPassword: (id: string) => `/users/${id}/reset-password`
    },
    organizadores: '/organizadores',
    organizadoresUsuarios: {
      base: '/organizadoresusuarios',
      byUserId: (userid: string) => `/organizadoresusuarios/${userid}`,
      byOrganizador: (organizadorid: string) => `/organizadores/${organizadorid}/usuarios`
    },
    organizadoresVendedores: {
      byOrganizador: (organizadorid: string) => `/organizadores/${organizadorid}/vendedores`,
      byId: (organizadorid: string, vendedorid: string) => `/organizadores/${organizadorid}/vendedores/${vendedorid}`,
      estado: (organizadorid: string, vendedorid: string) => `/organizadores/${organizadorid}/vendedores/${vendedorid}/estado`
    },
    eventos: '/eventos',
    tiposTicket: '/tipos-ticket',
    tipoTicketById: (eventoid: string, tipoticketid: string) => `/eventos/${eventoid}/tipos-ticket/${tipoticketid}`,
    deleteTipoTicketFullMultiple: (eventoid: string) => `/eventos/${eventoid}/tipos-ticket/delete-full-multiple`,
    tickets: {
      byEvento: (eventoid: string) => `/eventos/${eventoid}/tickets`,
      byId: (eventoid: string, ticketid: string) => `/eventos/${eventoid}/tickets/${ticketid}`,
      estado: (eventoid: string, ticketid: string) => `/eventos/${eventoid}/tickets/${ticketid}/estado`,
      bloquear: (eventoid: string, ticketid: string) => `/eventos/${eventoid}/tickets/${ticketid}/bloquear`,
      disponible: (eventoid: string, ticketid: string) => `/eventos/${eventoid}/tickets/${ticketid}/disponible`,
      bloqueos: {
        base: (eventoid: string) => `/eventos/${eventoid}/bloqueos-tickets`,
        byId: (eventoid: string, bloqueoid: string) => `/eventos/${eventoid}/bloqueos-tickets/${bloqueoid}`,
        historial: (eventoid: string, bloqueoid: string) => `/eventos/${eventoid}/bloqueos-tickets/${bloqueoid}/historial`
      }
    },
    tipoTicketTickets: (eventoid: string, tipoticketid: string) => `/eventos/${eventoid}/tipos-ticket/${tipoticketid}/tickets`,
    cloneBulkTipoTicket: (eventoid: string, tipoticketid: string) => `/eventos/${eventoid}/tipos-ticket/${tipoticketid}/clone-bulk`,
    ticketsFullReport: (eventoid: string) => `/eventos/${eventoid}/ticketsfullreport`,
    ticketsDashboardReport: (eventoid: string) => `/eventos/${eventoid}/ticketsdashboardreport`,
    ticketsDashboardSummary: (eventoid: string) => `/eventos/${eventoid}/ticketsdashboardsummary`,
    tiposTicketStats: (eventoid: string) => `/eventos/${eventoid}/tipos-ticket/stats`,
    cart: '/cart',
    configurations: '/configurations',
    summary: (eventoid: string) => `/eventos/${eventoid}/summary`,
    validadores: {
      base: (eventoid: string) => `/eventos/${eventoid}/validadores`,
      byId: (eventoid: string, validadorid: string) => `/eventos/${eventoid}/validadores/${validadorid}`,
      estado: (eventoid: string, validadorid: string) => `/eventos/${eventoid}/validadores/${validadorid}/estado`,
      resend: (eventoid: string, validadorid: string) => `/eventos/${eventoid}/validadores/${validadorid}/resend`,
      tipoTicket: (eventoid: string, validadorid: string) => `/eventos/${eventoid}/validadores/${validadorid}/tipoticket`,
      tipoTicketUpdate: (eventoid: string, validadorid: string, tipoticketid: string) => `/eventos/${eventoid}/validadores/${validadorid}/tipoticket/${tipoticketid}`,
      subeventos: (eventoid: string, validadorid: string) => `/eventos/${eventoid}/validadores/${validadorid}/subeventos`
    },
    config: {
      base: '/config',
      all: '/config',
      email: '/config/email',
      company: '/config/company',
      eventoImages: '/config/evento-images',
      apiKeys: '/config/api-keys',
      appsync: '/config/appsync',
      googleMaps: '/config/google-maps',
      webapp: '/config/webapp',
      pagination: '/config/pagination',
      bySK: (sk: string) => `/config/${sk}`
    },
    facturadores: {
      base: '/facturadores',
      byId: (id: string) => `/facturadores/${id}`,
      logo: (id: string) => `/facturadores/${id}/logo`,
      certificado: (id: string) => `/facturadores/${id}/certificado`
    },
    configuracionFacturacion: {
      get: (eventoid: string) => `/eventos/${eventoid}/configuracion-facturacion-electronica`,
      update: (eventoid: string) => `/eventos/${eventoid}/configuracion-facturacion-electronica`
    },
    listasTickets: {
      base: (eventoid: string) => `/eventos/${eventoid}/listas`,
      byId: (eventoid: string, listaticketid: string) => `/eventos/${eventoid}/listas/${listaticketid}`,
      tickets: (eventoid: string, listaticketid: string) => `/eventos/${eventoid}/listas/${listaticketid}/tickets`
    },
    facturas: {
      base: (eventoid: string) => `/eventos/${eventoid}/facturas`,
      byId: (eventoid: string, facturaid: string) => `/eventos/${eventoid}/facturas/${facturaid}`,
      byIdSimple: (facturaid: string) => `/facturas/${facturaid}`,
      details: (eventoid: string, facturaid: string) => `/eventos/${eventoid}/facturas/${facturaid}/details`,
      reasignarTicket: (eventoid: string, facturaid: string) => `/eventos/${eventoid}/facturas/${facturaid}/reasignarticket`,
      ticketFormDataUpdate: (eventoid: string, ticketid: string, templateformid: string) => `/eventos/${eventoid}/tickets/${ticketid}/formdata/${templateformid}`,
      resendemail: (eventoid: string, facturaid: string) => `/eventos/${eventoid}/facturas/${facturaid}/details/resendemail`,
      anular: (eventoid: string, facturaid: string) => `/eventos/${eventoid}/facturas/${facturaid}/anular`,
      sri: {
        factura: (eventoid: string, facturaid: string) => `/eventos/${eventoid}/facturas/${facturaid}/sri/factura`,
        ride: (eventoid: string, facturaid: string) => `/eventos/${eventoid}/facturas/${facturaid}/sri/ride`,
        xml: (eventoid: string, facturaid: string) => `/eventos/${eventoid}/facturas/${facturaid}/sri/xml`
      }
    },
    cartlog: {
      base: (eventoid: string) => `/eventos/${eventoid}/cartlog`,
      byId: (eventoid: string, cartid: string) => `/eventos/${eventoid}/cartlog/${cartid}`
    },
    adminSummary: {
      admin: '/summary/role/admin',
      organizador: (organizadorid: string) => `/summary/role/organizador/${organizadorid}`
    },
    seatmaps: {
      base: '/seatmaps',
      byId: (seatmapid: string) => `/seatmaps/${seatmapid}`,
      copy: (seatmapid: string) => `/seatmaps/${seatmapid}/copy`
    },
    templateforms: {
      base: '/templateforms',
      byId: (templateformid: string) => `/templateforms/${templateformid}`,
      bySlug: (slug: string) => `/templateforms/slug/${slug}`,
      duplicate: (templateformid: string) => `/templateforms/${templateformid}/duplicate`
    },
    categoriasEventos: {
      base: '/categorias-eventos',
      byId: (categoriaeventoid: string) => `/categorias-eventos/${categoriaeventoid}`
    },
    eventoforms: {
      base: '/eventoforms',
      byIds: (eventoid: string, templateformid: string) => `/eventoforms/${eventoid}/${templateformid}`,
      byEvento: (eventoid: string) => `/eventos/${eventoid}/forms`,
      updateOrder: (eventoid: string, templateformid: string) => `/eventoforms/${eventoid}/${templateformid}`,
      updateOrderBulk: (eventoid: string) => `/eventos/${eventoid}/forms/order`
    },
    subeventos: {
      base: (eventoid: string) => `/eventos/${eventoid}/subeventos`,
      byId: (eventoid: string, subeventoid: string) => `/eventos/${eventoid}/subeventos/${subeventoid}`,
      estado: (eventoid: string, subeventoid: string) => `/eventos/${eventoid}/subeventos/${subeventoid}/estado`,
      imageSpecs: (eventoid: string) => `/eventos/${eventoid}/subeventos/images/specs`,
      uploadImage: (eventoid: string, subeventoid: string) => `/eventos/${eventoid}/subeventos/${subeventoid}/images/upload`
    },
    eventoFunciones: {
      byTipoTicket: (tipoticketid: string) => `/tipos-ticket/${tipoticketid}/funcion`,
      upsert: (tipoticketid: string) => `/tipos-ticket/${tipoticketid}/funcion`,
      byEvento: (eventoid: string) => `/eventos/${eventoid}/funciones`,
      byEventoLight: (eventoid: string) => `/eventos/${eventoid}/funciones-light`
    },
    eventoUbicaciones: {
      base: (eventoid: string) => `/eventos/${eventoid}/ubicaciones`,
      byId: (eventoid: string, eventoubicacionid: string) => `/eventos/${eventoid}/ubicaciones/${eventoubicacionid}`,
      reorder: (eventoid: string, eventoubicacionid: string) => `/eventos/${eventoid}/ubicaciones/${eventoubicacionid}/reorder`
    },
    eventoRubros: {
      base: (eventoid: string) => `/eventos/${eventoid}/rubros`,
      byId: (eventoid: string, eventorubroid: string) => `/eventos/${eventoid}/rubros/${eventorubroid}`
    }
  },
  storage: {
    tokenKey: 'access_token',
    refreshTokenKey: 'refresh_token',
    userKey: 'current_user'
  },
  /**
   * Configuración de autenticación con cookies HTTP-only
   * 
   * Cuando está habilitado (true):
   * - Los tokens se almacenan en cookies HTTP-only en el servidor
   * - Las cookies se envían automáticamente en cada petición
   * - Más seguro contra ataques XSS
   * - Ver documentación completa en: docs/HTTP_ONLY_COOKIES_GUIDE.md
   * 
   * Cuando está deshabilitado (false):
   * - Los tokens se almacenan en el cliente (Capacitor Preferences/localStorage)
   * - Se envían manualmente mediante el interceptor
   * 
   * ⚠️ IMPORTANTE: Para habilitar cookies HTTP-only, el backend DEBE:
   * 1. Responder con Access-Control-Allow-Origin: <origin específico>
   * 2. NO puede usar Access-Control-Allow-Origin: *
   * 3. Debe incluir Access-Control-Allow-Credentials: true
   * 4. TODOS los endpoints deben estar configurados correctamente
   * 
   * @default true
   */
  cookie_http_only: current_httponly_config
} as const;
